import { render, staticRenderFns } from "./PatientFilter.vue?vue&type=template&id=320680d3&"
import script from "./PatientFilter.vue?vue&type=script&lang=js&"
export * from "./PatientFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports